/// <amd-module name="Repos/Views/PullRequest/Util/Filter" />
import * as React from "react";
import { IObservableValue } from "VSS/Core/Observable";
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";
import { css } from "VSS/Platform/Layout";
import { renderSelectedFilterItems } from "VSSUI/Filter";
import { IListBoxItem } from "VSSUI/ListBox";
import { Observer } from "VSSUI/Observer";
import { Persona, PersonaSize } from "VSSUI/Persona";
import { ITableColumn } from "VSSUI/Table";
import { IFilter } from "VSSUI/Utilities/Filter";

export function renderFilterIdentityRowWithCount(
    count: IObservableValue<number>,
    rowIndex: number,
    columnIndex: number,
    tableColumn: ITableColumn<IListBoxItem<string | IdentityRef>>,
    tableItem: IListBoxItem<string | IdentityRef>
): JSX.Element {
    return (
        <td key={`row-${rowIndex}-col-${columnIndex}`} className="bolt-list-box-text bolt-list-box-text-single-select bolt-table-cell bolt-list-cell">
            <div className="bolt-table-cell-content flex-row flex-center rhythm-horizontal-4">
                {!tableItem.data && <span className="text-ellipsis flex-grow">{tableItem.text}</span>}
                {tableItem.data && (
                    <div className="text-ellipsis rhythm-horizontal-4 flex-row flex-center flex-grow">
                        <Persona identity={tableItem.data as IdentityRef} size={PersonaSize.size20} />
                        <span>{tableItem.text}</span>
                    </div>
                )}
                <Observer count={count}>{(props: { count: number }) => <span className="body-s secondary-text">{props.count}</span>}</Observer>
            </div>
        </td>
    );
}

export function renderFilterRowWithCount(
    count: IObservableValue<number>,
    rowIndex: number,
    columnIndex: number,
    tableColumn: ITableColumn<IListBoxItem<string>>,
    tableItem: IListBoxItem<string>
): JSX.Element {
    return (
        <td key={`row-${rowIndex}-col-${columnIndex}`} className="bolt-list-box-text bolt-list-box-text-single-select bolt-table-cell bolt-list-cell">
            <div className="bolt-table-cell-content flex-row flex-center rhythm-horizontal-4">
                <span className="flex-grow text-ellipsis">{tableItem.text}</span>
                <Observer count={count}>{(props: { count: number }) => <span className="body-s secondary-text">{props.count}</span>}</Observer>
            </div>
        </td>
    );
}

export function renderSelectedFilterItemsConditionally(
    filterStore: IFilter,
    filterKey: string,
    selectedItems: IListBoxItem<string>[]
): JSX.Element | null {
    if (selectedItems.length > 0) {
        const defaultItemState = filterStore.getDefaultState()[filterKey];
        const itemState = filterStore.getFilterItemState(filterKey);

        // Render only if the filter item state is different than the default
        if (!filterStore.filterItemStatesAreEqual(filterKey, itemState, defaultItemState)) {
            return renderSelectedFilterItems(selectedItems);
        }
    }

    return null;
}

export function renderSelectedFilterIdentityConditionally(
    filterStore: IFilter,
    filterKey: string,
    selectedItems: IListBoxItem<IdentityRef>[]
): JSX.Element | null {
    if (selectedItems.length > 0) {
        const defaultItemState = filterStore.getDefaultState()[filterKey];
        const itemState = filterStore.getFilterItemState(filterKey);

        // Render only if the filter item state is different than the default
        if (!filterStore.filterItemStatesAreEqual(filterKey, itemState, defaultItemState)) {
            return (
                <>
                    {selectedItems.map((selectedItem, index) => {
                        return (
                            <div className={css("bolt-filter-selected-item")} key={selectedItem.id}>
                                <span className="bolt-list-cell-text text-ellipsis flex-row flex-center rhythm-horizontal-4">
                                    <Persona identity={selectedItem.data as IdentityRef} size={PersonaSize.size20} />
                                    <span>{selectedItem.text}</span>
                                </span>
                            </div>
                        );
                    })}
                </>
            );
        }
    }

    return null;
}
